module.exports = __webpack_public_path__ + "static/img/ivoice_bg@2x.41468b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/ivoice_bg@2x.jpg
// module id = 503
// module chunks = 0